import { Link } from "react-router-dom";
import FavoriteButton from "@/components/feature/FavoriteButton";
import { getActorsByMovie, formatReleaseDate } from "@/utils/movie";

interface Props {
  movie: any;
  variant?: "grid" | "list";
}

export default function MovieCard({ movie, variant = "grid" }: Props) {
  if (!movie) return null;
  const cast = getActorsByMovie(movie).map((a: any) => a.name).slice(0, 3).join(" / ");

  if (variant === "list") {
    return (
      <Link
        href={`/detail/${movie.id}`}
        to={`/detail/${movie.id}`}
        className="group flex gap-4 p-3 md:p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-[100px] sm:w-[120px] shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
          <img
            src={movie.poster}
            alt={`${movie.title}（${movie.year}）影视海报`}
            title={`${movie.title} 剧情介绍与演员表`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
              {movie.title}
            </h3>
            <span className="shrink-0 inline-flex items-center gap-1 text-sm text-accent-700 font-medium">
              <i className="ri-star-fill text-accent-500"></i>
              {movie.rating}
            </span>
          </div>
          <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
            <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">{movie.type}</span>
            <span>{movie.region}</span>
            <span>{formatReleaseDate(movie.releaseDate)}</span>
          </div>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{movie.summary}</p>
          <p className="mt-2 text-xs text-foreground-500 truncate">
            <span className="text-foreground-400">主演：</span>
            {cast}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <div className="group relative cursor-pointer">
      <Link href={`/detail/${movie.id}`} to={`/detail/${movie.id}`} className="block">
        <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
          <img
            src={movie.poster}
            alt={`${movie.title}（${movie.year}）影视海报`}
            title={`${movie.title} 剧情介绍与演员表`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-80"></div>
          <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-full text-[11px] font-medium bg-primary-500 text-background-50">
            {movie.type}
          </span>
          <span className="absolute bottom-2.5 left-2.5 inline-flex items-center gap-1 text-sm text-background-50 font-medium">
            <i className="ri-star-fill text-accent-400"></i>
            {movie.rating}
          </span>
          <span className="absolute bottom-2.5 right-2.5 text-xs text-background-100/90">{movie.year}</span>
        </div>
        <h3 className="mt-2.5 font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.region} · {(movie.genres || []).slice(0, 2).join(" ")}
        </p>
      </Link>
      <div className="absolute top-2.5 right-2.5 opacity-0 group-hover:opacity-100 transition-opacity">
        <FavoriteButton movieId={movie.id} />
      </div>
    </div>
  );
}